import { Media } from '../../types';
import api from '../../utils/api';
import { omit } from 'lodash/fp';

export const updateMedia = (variables: Media) =>
  api.put({
    url: `/media/${variables.id}`,
    variables: omit(['id'], variables),
  });
